export default __webpack_public_path__ + "static/media/Mindwreath Cap.2978d70f.jpg";